import { useEffect } from 'react';

import { types } from './definitions';

/**
 * Create a script element and append it to the HTML body
 *
 * @param src The script src
 * @param async Whether the script should be loaded asynchronously
 * @param defer Whether the script should be deferred (loaded after the document has been parsed)
 */
const useScript = ({
  src,
  async = true,
  defer = true,
  disabled = false,
}: types.UseScriptArgs): void => {
  useEffect(() => {
    if (disabled) {
      return;
    }

    const script = document.createElement('script');

    script.src = src;
    script.async = async;
    script.defer = defer;

    document.body.appendChild(script);

    return (): void => {
      document.body.removeChild(script);
    };
  }, [src]);
};

export default useScript;
